import React, { useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button as RKSButton } from '@uncinc/uncinc-react-kitchen-sink';
import useInfiniteResults from '../../../hooks/useInfiniteResults';
import useLoading from '../../../hooks/useLoading';
import List from '../List';
import './style.scss';
const SearchResultsInfinite = props => {
  const {
    t
  } = useTranslation();
  const {
    renderItem,
    emptyState,
    showMoreButton,
    showMoreButtonText = t('searchkit.buttons.show_more'),
    autoScroll,
    className
  } = props;
  const sentinelRef = useRef(null);
  const {
    hits,
    isLastPage,
    showMore
  } = useInfiniteResults(sentinelRef, autoScroll);
  const {
    isLoading
  } = useLoading();
  const classNames = c('Searchkit__SearchResultsInfinite', className);
  const Button = showMoreButton || RKSButton;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(List, {
    hits: hits,
    renderItem: renderItem,
    emptyState: emptyState
  }), /*#__PURE__*/React.createElement("div", {
    ref: sentinelRef,
    className: "Searchkit__SearchResultsInfinite__sentinel",
    "aria-hidden": "true"
  }), hits.length > 0 && !isLastPage && /*#__PURE__*/React.createElement(Button, {
    className: "Searchkit__SearchResultsInfinite__showMore",
    loading: isLoading,
    onClick: () => {
      if (!isLoading) {
        showMore();
      }
    }
  }, showMoreButtonText));
};
export default SearchResultsInfinite;